import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ParFormFieldComponent, ParInputDatepickerDirective } from '@shared/ui';
import { KeyValuePipe, NgClass } from '@angular/common';
import { DynamicFormControlDirective } from '../../dynamic-form-control.directive';
import { AbstractDynamicFormControl } from '../../abstact-dynamic-form-control.directive';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { matCalendarMonthRound } from '@ng-icons/material-symbols/round';
@Component({
  selector: 'dynamic-form-date-control',
  templateUrl: 'date-control.component.html',
  styleUrls: ['date-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    ParInputDatepickerDirective,
    NgClass,
    ParFormFieldComponent,
    KeyValuePipe,
    NgIconComponent,
  ],
  providers: [
    {
      provide: DynamicFormControlDirective,
      useExisting: DynamicFormDateControlComponent,
    },
    provideIcons({ matCalendarMonthRound }),
  ],
})
export class DynamicFormDateControlComponent extends AbstractDynamicFormControl {}
